import { Component, OnInit, HostListener } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
// import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from '@angular/router';
import { Subscription } from 'rxjs';
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { environment } from '../environments/environment.prod';
import { ErrorShowService } from './services/error-show.service';
import { commonClass, notificationDM, notificationDocComments, notificationDocNew } from './models/commonClass';
import { NavbarDateShareService } from './services/navbar-date-share.service';
import { TokenService } from './services/token.service';
import { DataService } from './services/data.service';
import { SocketService } from './services/socketService.service';

export let browserRefresh = false;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  subscription: Subscription;
  message: any = null;

  constructor(private dataService: DataService, private router: Router, private msgShowService: ErrorShowService, private navShareService: NavbarDateShareService, private tokenService: TokenService, private socketService: SocketService) {
    this.subscription = router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !router.navigated;
        if (browserRefresh && localStorage.getItem("auth-code")) {
          this.connectSocket(localStorage.getItem("auth-code"))
        }
      }
    });
    this.navShareService.authCode$.subscribe(auth => {
      if (auth) {
        this.connectSocket(auth);
      }
    })
  }

  messages: string[] = [];
  connectSocket(auth) {
    this.socketService.connect(environment.socketUrl, auth)
    this.socketService.messageSent.subscribe((event) => {
      var push = JSON.parse(event);
      var pushMessage = push['message'];
      if (!pushMessage) {
        return
      }
      console.log(pushMessage)
      let isSamePage: boolean = false;
      if (pushMessage['notiType'] == "Direct_Message") {
        //if (pushMessage['type'] != "Delete Chat") {
          isSamePage = true;
          let dmObj = pushMessage as notificationDM;
          dmObj.message = this.message;
          //if (dmObj.subprojectid != this.tokenService.getSubprojectID()) {
          //  this.navShareService.setfrenchiseUpdate(dmObj)
          //}
          //else {
            this.dataService.proceedForDMNotification(dmObj);
          //}
        //}
      }
      else if(pushMessage['notiType'] == "New_Document"){
        var docObj = pushMessage as notificationDocNew;
        docObj.message = this.message
        if (docObj.subprojectid != this.tokenService.getSubprojectID()) {
          //update subproject
          this.navShareService.setfrenchiseUpdate(docObj)
        }
        else {
          this.dataService.proceedForDocNotification(docObj);
        }
      }
      else if (pushMessage['notiType'] == "Document_Comments") {
        var comObj = pushMessage as notificationDocComments;
        comObj.message = this.message
        if (comObj.subprojectid != this.tokenService.getSubprojectID()) {
          //update subproject
          this.navShareService.setfrenchiseUpdate(comObj)
        }
        else {
          this.dataService.proceedForDocCommentNotification(comObj);
        }
      }
    })
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  @HostListener("window:onbeforeunload", ["$event"])
  clearLocalStorage(event) {
    localStorage.clear();
  }
 
}
